import axios from "axios";
import { getValidAccessToken, renewToken } from './authManager';

const baseUrl = process.env.REACT_APP_API_BASE_URL ? `${process.env.REACT_APP_API_BASE_URL}/v1` : 'http://localhost:5000/v1';

const api = axios.create({
    baseURL: baseUrl,
    // Evita requests pendurados para sempre (ex.: app voltando do background no iOS)
    timeout: 30000,
});

api.interceptors.request.use(async (config) => {
    try {
        const token = await getValidAccessToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    } catch (err) {
        // Sem token válido: segue sem Authorization (a API responde 401)
        console.warn("[AUTH] Could not get a valid access token:", err);
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Normalize backend error message into a convenient property
        error.apiMessage = error.response?.data?.errorMessage || null;

        if (error.response?.status !== 401 || !originalRequest || originalRequest._retry) {
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        try {
            const user = await renewToken();
            originalRequest.headers.Authorization = `Bearer ${user.access_token}`;
            return api(originalRequest);
        } catch (refreshError) {
            console.error("[AUTH] Token renew after 401 failed:", refreshError);
            return Promise.reject(error);
        }
    }
);

export default api;
